import { i18n } from '../../i18n/translate';

export const everfiAdminNavigation = (environment = { MENU_DOMAIN_FOR_ADMINIFI: '' }, service) => {
  const { MENU_DOMAIN_FOR_ADMINIFI, MENU_DOMAIN_FOR_FRONT_END, MENU_DOMAIN_FOR_NEXT } = environment;

  const menu = {
    id: 'foundry--universal_navigation--menus--everfi_admin_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--everfi_admin_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [
      {
        id: '',
        slug: 'help',
        title: i18n.t('Help'),
        icon: 'circle-question',
        font_family: '',
        css_class: '',
        target_url: 'https://workplacehelp.everfi.com',
        target_method: '',
        new_window: true,
        subsection: false,
        submenu_items: [],
        weight: 100,
      },
      {
        id: 'account',
        slug: 'account',
        title: '{{user_name}}',
        icon: 'circle-user',
        font_family: '',
        css_class: 'account',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: true,
        weight: 99,
        submenu_items: [
          {
            id: '',
            slug: 'logout',
            title: i18n.t('Logout'),
            icon: '',
            font_family: '',
            css_class: '',
            target_url: `${MENU_DOMAIN_FOR_ADMINIFI}/admin/session`,
            target_method: 'GET',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
        ],
      },
    ],
  };

  if (service === 'next') {
    if (MENU_DOMAIN_FOR_FRONT_END) {
      menu.submenu_items.unshift({
        id: '',
        slug: '',
        module: 'adminifi',
        title: i18n.t('Goto Foundry'),
        icon: 'shuffle',
        font_family: '',
        css_class: '',
        target_url: `${MENU_DOMAIN_FOR_FRONT_END}/admin`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      });
    }
  } else {
    if (MENU_DOMAIN_FOR_NEXT) {
      menu.submenu_items.unshift({
        id: '',
        module: 'next',
        slug: '',
        title: i18n.t('Goto Next'),
        icon: 'shuffle',
        font_family: '',
        css_class: '',
        permissions: [{ admin_has_permission: ['manage_next'] }],
        target_url: `${MENU_DOMAIN_FOR_NEXT}/admin/accounts`,
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [],
        weight: 100,
      });
    }
  }

  return menu;
};
